module.exports = __webpack_public_path__ + "static/img/01.3c70e12c.png";